import {batch} from 'react-redux';

import {showAlert} from '@/actions/setupActions';
import {ALERT_TYPE} from '@/constants/enums';
import HTTPStatusCode from '@/constants/httpStatusCode';
import {consoleError} from '@/libs/consoleHelper';
import businessObserver from '@/observers/businessObserver';

export const handleSessionExp = () => () => {
  batch(() => {
    // dispatch(setOpenLoginPage(true));
    // dispatch(setSessionTimeout(true));
  });
};

export const handleErrorResponse =
  (response, requestName = '') =>
  (dispatch) => {
    try {
      console.log('handleErrorResponse', response);
      const message =
        // eslint-disable-next-line no-nested-ternary
        response === undefined
          ? 'No Connection'
          : response === undefined || response.data.message === undefined
          ? response.toString()
          : response.data.message;

      if (message === 'Error: Network Error') throw new Error(message);

      dispatch(
        showAlert({
          alertShow: true,
          alertText: message,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } catch (e) {
      console.error('Log Execption:', e);
      dispatch(
        showAlert({
          alertShow: true,
          alertText: `${e.name}: ${e.message} ${requestName !== '' ? ` when request ${requestName}` : ''}`,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );
      // window.location.href = '#/error';
      throw e;
    } finally {
      businessObserver.removeAll();
    }
  };

export const handleError =
  (error, requestName = '') =>
  (dispatch) => {
    try {
      console.log('handleError', error, error?.response);
      const responseCode = error?.response?.status;

      if (
        (responseCode &&
          [
            HTTPStatusCode.INTERNAL_SERVER_ERROR,
            HTTPStatusCode.NOT_IMPLEMENTED,
            HTTPStatusCode.BAD_GATEWAY,
            HTTPStatusCode.SERVICE_UNAVAILABLE,
            HTTPStatusCode.GATEWAY_TIMEOUT,
            HTTPStatusCode.HTTP_VERSION_NOT_SUPPORTED,
            HTTPStatusCode.NOT_EXTENDED,
            HTTPStatusCode.NETWORK_AUTHENTICATION_REQUIRED,
            HTTPStatusCode.NETWORK_READ_TIMEOUT_ERROR,
            HTTPStatusCode.NETWORK_CONNECT_TIMEOUT_ERROR,
          ].includes(responseCode)) ||
        error.response === undefined
      )
        throw error;

      let message =
        // eslint-disable-next-line no-nested-ternary
        error.response === undefined
          ? 'No Connection'
          : error.response === undefined || error.response.data.message === undefined
          ? error.response.toString()
          : error.response.data.message;

      switch (responseCode) {
        case HTTPStatusCode.NOT_FOUND:
          message =
            typeof error.response.data === 'string' && error.response.data
              ? error.response.data
              : error.response.statusText;
          break;

        default:
          break;
      }

      if (message === 'Error: Network Error') throw new Error(message);

      dispatch(
        showAlert({
          alertShow: true,
          alertText: message,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );

      // const responseCode = response.status;
      // const responseRequest = response.request;
      // const responseData = response.data;
      // const {status, statusText: statusTextError, responseURL} = responseRequest || {};
      // const {errors, status: errorStatus} = responseData || {};

      // let txtError = '';
      // if (responseData?.errors) {
      //   txtError = errors.keyParam ? errors.keyParam[0] : errors.SessionKey[0];
      // } else {
      //   txtError = responseData?.title;
      // }

      // const {statusText} = responseRequest || {};
      // switch (responseCode) {
      //   case HTTPStatusCode.INTERNAL_SERVER_ERROR:
      //     dispatch(
      //       showToast(
      //         FmlxToast.Variant.ERROR,
      //         `Responses Code ${status}`,
      //         `${statusTextError} - ${RestAPIMethod.POST} ${responseURL}`,
      //       ),
      //     );
      //     break;
      //   case HTTPStatusCode.NOT_FOUND:
      //     dispatch(showToast(FmlxToast.Variant.ERROR, `Responses Code ${responseCode}`, `${statusText}`));
      //     break;
      //   case HTTPStatusCode.METHOD_NOT_ALLOWED:
      //     dispatch(showToast(FmlxToast.Variant.ERROR, `Responses Code: ${responseData?.error.code}`, `${statusText}`));
      //     break;
      //   case HTTPStatusCode.BAD_REQUEST:
      //     dispatch(showToast(FmlxToast.Variant.ERROR, `Responses Code ${errorStatus}`, `${statusText} : ${txtError}`));
      //     break;
      //   default:
      //     dispatch(showToast(FmlxToast.Variant.ERROR, `Responses Code ${errorStatus}`, `${statusText} : ${txtError}`));
      //     break;
      // }
    } catch (e) {
      console.error('Log Execption:', e, e?.message);
      dispatch(
        showAlert({
          alertShow: true,
          alertText: `${e.name}: ${e.message} ${requestName !== '' ? ` when request ${requestName}` : ''}`,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );
      throw e;
      // window.location.href = '#/error';
      // dispatch(
      //   showToast(
      //     FmlxToast.Variant.ERROR,
      //     'Something went wrong!',
      //     `${e}${requestName !== '' ? ` when request ${requestName}` : ''}`,
      //     // content: 'Please check exception details on console log',
      //   ),
      // );
    } finally {
      businessObserver.removeAll();
    }
  };

// Don't use this, use error/failure
export const handleRequestFailure = (response) => (dispatch) => {
  if (response.data.message)
    dispatch(
      showAlert({
        alertShow: true,
        alertText: response.data.message,
        alertStyle: ALERT_TYPE.ALERT_DANGER,
      }),
    );
};

export function reqError(errorParam) {
  return (dispatch) => {
    consoleError('reqError : ', errorParam);
    // const message =
    //   errorParam === undefined
    //     ? 'No Connection'
    //     : errorParam.response === undefined || errorParam.response.data.message === undefined
    //     ? errorParam.toString()
    //     : errorParam.response.data.message;
    dispatch(
      showAlert({
        alertShow: true,
        alertText: errorParam.response.data.message,
        alertStyle: ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };
}
export function reqFailure(response) {
  return (dispatch) => {
    consoleError('reqFailure : ', response.data.message);
    dispatch(
      showAlert({
        alertShow: true,
        alertText: response.data.message,
        alertStyle: ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };
}
